export default __webpack_public_path__ + "static/media/icon-ab-testing.1b277731.svg";